import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Eraser } from "lucide-react";
import { Button } from "../ui/button";

// Canvas com largura real do container para evitar deslocamento do traço em touch
export const AssinaturaCanvas = forwardRef(function AssinaturaCanvas({ testId = "assinatura-canvas", height = 180 }, ref) {
  const boxRef = useRef(null);
  const sigRef = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const medir = () => setWidth(boxRef.current?.clientWidth || 0);
    medir();
    window.addEventListener("resize", medir);
    return () => window.removeEventListener("resize", medir);
  }, []);

  useImperativeHandle(ref, () => ({
    isEmpty: () => !sigRef.current || sigRef.current.isEmpty(),
    toDataURL: () => sigRef.current.getCanvas().toDataURL("image/png"),
    clear: () => sigRef.current?.clear(),
  }));

  return (
    <div>
      <div ref={boxRef} className="rounded-md border-2 border-dashed border-slate-300 bg-white" data-testid={`${testId}-box`}>
        {width > 0 && (
          <SignatureCanvas
            ref={sigRef}
            penColor="#0f1923"
            canvasProps={{ width, height, className: "block touch-none cursor-crosshair", "data-testid": testId }}
          />
        )}
      </div>
      <div className="flex items-center justify-between mt-2">
        <span className="text-xs text-muted-foreground">Assine com o dedo ou com o mouse</span>
        <Button type="button" size="sm" variant="outline" onClick={() => sigRef.current?.clear()} data-testid={`${testId}-limpar`}>
          <Eraser size={12} className="mr-1" /> Limpar
        </Button>
      </div>
    </div>
  );
});
